import cn from 'classnames';
import type { FC } from 'react';
import { Moderation } from '@shared/assets';
import { usePlatformSettings } from '@shared/hooks';
import { type ModerationStatus } from '@src/library/models/events';
import * as st from './styles.module.scss';

export type ModerationStatusViewerProps = {
  isPublished: boolean;
  moderationStatus: ModerationStatus;
  isNeedToShowOnlyIcon?: boolean;
};

export const ModerationStatusViewer: FC<ModerationStatusViewerProps> = ({
  isPublished,
  moderationStatus,
  isNeedToShowOnlyIcon = false,
}) => {
  const { moderation } = usePlatformSettings();
  // const { showStatus, redirectPublishSettings } = useProgramPublish(programId);

  const settings: {
    [x: string]: {
      text: string;
      secondText?: string;
      style: string;
      // action: () => void;
    };
  } = {
    N: {
      text: 'Модерация',
      style: cn(st.wrapper, st.moderation),
      // action: () => showStatus(),
    },
    D: {
      text: 'Отклонено',
      style: cn(st.wrapper, st.ban),
      // action: () => showStatus(),
    },
    U: {
      text: 'Не опубликована',
      secondText: 'Опубликовать',
      style: cn(st.wrapper, st.publishNo),
      // action: () => redirectPublishSettings(programId),
    },
    A: {
      text: 'Опубликована',
      secondText: 'Снять с публикации',
      style: cn(st.wrapper, st.publishOk),
      // action: () => redirectPublishSettings(programId),
    },
  };

  const actionKey =
    moderation && isPublished
      ? moderationStatus.abbr_status
      : !moderation && isPublished
        ? 'A'
        : 'U';

  return (
    <div className={settings[actionKey].style}>
      {!isNeedToShowOnlyIcon && <p>{settings[actionKey].text}</p>}
      {actionKey !== 'A' && (
        <div className={st.icon__wrapper}>
          <Moderation />
        </div>
      )}
    </div>
  );
};
